import { BasePage } from '@Tenants/Hw/Site/BasePage';
import { BaseCouponsAndDiscounts, ICoupon } from '@Base/CouponsAndDiscounts/CouponsAndDiscounts';

import "./CouponsAndDiscounts.scss";
import queryString from 'query-string';

export class CouponsAndDiscounts extends BaseCouponsAndDiscounts
{
	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		const parsed = queryString.parse(location.search);
		const simulateDateString = parsed.simulateDate as string;
		const simulateDate = new Date(simulateDateString);
		let currentDate: Date;
		let subscribeCoupon: ICoupon;

		if (simulateDate instanceof Date && !isNaN(simulateDate.getTime()))
		{
			currentDate = simulateDate;
		}
		else
		{
			currentDate = new Date();
		}

		this.SiteCoupons = [
			{
				Type: "military",
				MobileCreativeID: "1110909",
				DesktopCreativeID: "1110912",
				SignUpSource: "HWUSMilitary",
				ButtonSelector: ".military-js"
			},
			{
				Type: "student",
				MobileCreativeID: "1112750",
				DesktopCreativeID: "1112738",
				SignUpSource: "HWUSStudent",
				ButtonSelector: ".student-js"
			}
		];

		// Orange Tuesday 2026 Email Sign Up Ad
		if (new Date("09/07/2026") < currentDate && currentDate < new Date("09/09/2026"))
		{
			subscribeCoupon = {
				Type: "subscribe",
				MobileCreativeID: "1432573",
				DesktopCreativeID: "1432574",
				SignUpSource: "HWUSOrangeTuesday2026",
				ButtonSelector: ".subscribe-js"
			};
		}
		else
		{
			subscribeCoupon = {
				Type: "subscribe",
				MobileCreativeID: "1113062",
				DesktopCreativeID: "1113064",
				SignUpSource: "HWUSPopup",
				ButtonSelector: ".subscribe-js"
			};
		}

		this.SiteCoupons.push(subscribeCoupon);

		super.Initialize();
	}
}

export class CouponsAndDiscountsPage extends BasePage
{
	public CouponsAndDiscounts: CouponsAndDiscounts;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.CouponsAndDiscounts = new CouponsAndDiscounts();
	}
}

const couponsAndDiscounts = new CouponsAndDiscountsPage();